"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = forEach;

function forEach(arr, callback) {
  var i = 0;
  var l = arr.length;

  for (; i < l; i++) {
    callback(arr[i], i);
  }
}
//# sourceMappingURL=foreach.js.map